import React from "react";
import PropTypes from "prop-types";
import { Paginator } from "primereact/paginator";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";
import useCurrentPageReportTemplate from "core/shared/hooks/useCurrentPageReportTemplate";
import DataExportListStore$ from "reports/data-export/data-export-list/stores/DataExportListStore";
import NewReportButton from "reports/data-export/data-export-list/components/header/NewReportButton";

const LeftBuffer = <div style={{ width: "6rem" }} />;

const handlePageChange = (evt) => {
  DataExportListStore$.tableState.assign({
    first: evt.first,
    page: evt.page,
    rows: evt.rows,
    totalPages: evt.totalPages,
  });
};

const Header = ({ props = {} }) => {
  // Destructured props are called "props" by PrimeReact which confuses ESLint, hence disable warning
  /* eslint-disable-next-line react/prop-types */
  const { first, rows, totalRecords } = props;
  const currentPageTemplate = useCurrentPageReportTemplate();

  return (
    <Paginator
      currentPageReportTemplate={currentPageTemplate}
      first={first}
      onPageChange={handlePageChange}
      leftContent={LeftBuffer}
      rightContent={NewReportButton}
      rows={rows}
      template={PrimeReactConstants.PAGINATOR.TEMPLATE}
      totalRecords={totalRecords}
    />
  );
};

Header.propTypes = {
  props: PropTypes.shape({
    first: PropTypes.number,
    rows: PropTypes.number,
    totalRecords: PropTypes.number,
  }),
};

export default Header;
